import JwtService from './jwtService'
import axiosIns from '@core/axios/axios'

export default function useJwt(jwtOverrideConfig) {
  const jwt = new JwtService(axiosIns, jwtOverrideConfig)

  return {
    jwt,
  }
}
